<div class="top-bar">
    <div class="left-panel">
        <img
            data-cy="header-logo"
            src="assets/images/iops-logo.png"
            class="logo"
            [ngClass]="{
                none: !responsive.isXLarge() && !responsive.isLarge(),
            }"
        />
        <div (click)="onOpenSidebar()" class="sidebar-icon">
            <span
                class="material-symbols-outlined"
                *ngIf="!sidebarExtends && sidebarHidden"
            >
                menu
            </span>
            <span
                class="material-symbols-outlined"
                *ngIf="sidebarExtends && sidebarHidden"
            >
                menu_open
            </span>
        </div>
        <app-header-latest-alarm
            data-testid="latestAlarm"
            [latestAlarm]="latestAlarm"
            [alarmStatusCount]="alarmStatusCount"
            [isAlarmWindowClosed]="alarmWindowOpen"
            (onAlarmWindowOpen)="onAlarmWindowOpen()"
            (onAlarmWindowClose)="onAlarmWindowClose()"
        ></app-header-latest-alarm>
    </div>
    <div class="buzzer-wrap" *ngIf="!responsive.isXSmall()">
        <button
            data-cy="header-stop-buzzer-button"
            class="buzzer-btn"
            [class.on]="isBuzzerActive"
            (click)="onStopBuzzer()"
        >
            <p>STOP BUZZER</p>
        </button>
    </div>
    <div class="right-panel">
        <div
            class="display-setting"
            *ngIf="!responsive.isXLarge() && !responsive.isXSmall()"
        >
            <span
                data-cy="header-collapsible-button"
                class="material-symbols-outlined"
                (click)="onOpenEnvironmentSettings(); $event.stopPropagation()"
            >
                display_settings
            </span>
            <app-environment-settings
                #environmentSettings
            ></app-environment-settings>
        </div>
        <app-environment-settings
            class="display-setting-xlarge"
            *ngIf="responsive.isXLarge()"
        ></app-environment-settings>
        <div class="timezone">
            <span data-cy="header-utc-time">{{ utctime }} UTC</span>
            <span data-cy="header-jst-time">{{ localtime }} JST</span>
        </div>
        <mat-icon
            data-cy="header-user-icon"
            svgIcon="default-user"
            *ngIf="isLoggedIn"
            style="cursor: pointer"
            (click)="onOpenSwitchAccounts($event)"
        ></mat-icon>
        <ng-container *ngIf="!isLoggedIn">
            <button
                data-cy="header-login-button"
                class="sign-in btn"
                (click)="onShowSigninRoleOverlay()"
            >
                {{ "header.ops.signin" | translate }}
            </button>
        </ng-container>
    </div>
</div>
<div class="alarm-window-container" *ngIf="alarmWindowOpen">
    <app-alarm-window
        [alarms]="alarms"
        [alarmIndex]="alarmIndex"
        (alarmWindowCloseEvent)="onAlarmWindowClose()"
        (previousAlarmEvent)="onPreviousAlarm()"
        (nextAlarmEvent)="onNextAlarm()"
    ></app-alarm-window>
</div>
<app-signin-role
    #signInRole
    (showPasswordOverlay)="onShowSigninPasswordOverlay($event, false)"
></app-signin-role>
<app-signin-password
    #signInPassword
    (goBack)="onShowSigninRoleOverlay()"
    (onCloseSidePanel)="closeSwitchAccounts()"
    (onSetSidePanelEvent)="setSidePanelEvent()"
></app-signin-password>
<app-sign-out
    #signOut
    (signInEmitter)="onShowSigninRoleOverlay()"
></app-sign-out>
<app-switch-accounts
    #switchAccounts
    (showPasswordOverlay)="onShowSigninPasswordOverlay($event, true)"
></app-switch-accounts>
